// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-reveal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  z-index: 1100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
}

.team-reveal-title {
  color: #ffffff;
  font-family: 'Kim';
  font-size: clamp(24px, 4vw, 36px);
  text-align: center;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  animation: fadeInDown 0.6s ease-out;
  position: absolute;
  top: 15vh;
}

.team-reveal-subtitle {
  text-align: center;
  color: #ffffff;
  margin-top: -15px;
  margin-bottom: 30px;
  font-size: 0.95rem;
  opacity: 0.75;
  font-family: 'Kim';
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
  animation: fadeInDown 0.6s ease-out 0.2s backwards;
  position: absolute;
  top: 30vh;
}

.team-reveal-grid {
  min-height: 20vh;
  display: flex;
  justify-content: center;
  margin-top: 0;
  gap: 25px;
  scrollbar-width: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.team-reveal-grid::-webkit-scrollbar {
  display: none;
}

@media (max-height: 600px) {
  .team-reveal-grid {
    gap: 2vw;
    margin-top: 0;
  }
  
  .team-reveal-wrapper .endgame_character {
    transform: scale(1);
  }

  .team-reveal-wrapper {
    animation: fadeRevealSmall 0.8s ease-out backwards;
  }

  @keyframes fadeRevealSmall {
    0% {
      opacity: 0;
      transform: scale(0.3) translateY(20px);
      filter: blur(10px) brightness(2);
    }
    50% {
      opacity: 0.8;
      transform: scale(0.55) translateY(-10px);
      filter: blur(0) brightness(1.5);
    }
    100% {
      opacity: 1;
      transform: scale(0.5) translateY(0);
      filter: blur(0) brightness(1);
    }
  }

  .team-reveal-title {
    top: 5vh;
  }

  .team-reveal-play-button {
    bottom: 5vh;
  }
}

.team-reveal-wrapper {
  cursor: pointer;
  transition: all 0.3s ease;
  animation: fadeReveal 0.8s ease-out backwards;
  position: relative;
  z-index: 1;
  transform: translateZ(0);
  will-change: transform;
  isolation: isolate;
}

/* Add different delays for each card */
.team-reveal-wrapper:nth-child(1) {
  animation-delay: 0.3s;
}

.team-reveal-wrapper:nth-child(2) {
  animation-delay: 0.6s;
}

.team-reveal-wrapper:nth-child(3) {
  animation-delay: 0.9s;
}

/* Add particle effects */
.team-reveal-wrapper::before {
  content: '';
  position: absolute;
  inset: -50%;
  background: 
    radial-gradient(circle at 30% 20%, rgba(81, 253, 255, 0.1) 0%, transparent 30%),
    radial-gradient(circle at 70% 60%, rgba(81, 253, 255, 0.1) 0%, transparent 30%),
    radial-gradient(circle at 50% 50%, rgba(81, 253, 255, 0.1) 0%, transparent 50%);
  filter: blur(10px);
  opacity: 0;
  animation: glowEffect 1.2s ease-out backwards;
  animation-delay: inherit;
  pointer-events: none;
  z-index: -1;
}

/* Add sparkle effects */
.team-reveal-wrapper::after {
  content: '';
  position: absolute;
  inset: -20px;
  background: 
    radial-gradient(2px 2px at 20% 30%, rgba(255, 255, 255, 0.8) 0%, transparent 100%),
    radial-gradient(2px 2px at 40% 70%, rgba(255, 255, 255, 0.8) 0%, transparent 100%),
    radial-gradient(2px 2px at 60% 20%, rgba(255, 255, 255, 0.8) 0%, transparent 100%),
    radial-gradient(2px 2px at 80% 60%, rgba(255, 255, 255, 0.8) 0%, transparent 100%);
  opacity: 0;
  animation: sparkleEffect 1.5s ease-out backwards;
  animation-delay: inherit;
  pointer-events: none;
  z-index: -1;
}

.team-reveal-wrapper:hover {
  transform: translateY(-5px);
  z-index: 2;
}

.team-reveal-wrapper.revealed {
  cursor: default;
  animation: revealCardNew 0.6s ease-out forwards;
}

/* Add reveal particle effects */
.team-reveal-wrapper.revealed::before {
  content: '';
  position: absolute;
  inset: -50%;
  background: 
    radial-gradient(circle at 30% 20%, rgba(81, 253, 255, 0.3) 0%, transparent 30%),
    radial-gradient(circle at 70% 60%, rgba(81, 253, 255, 0.3) 0%, transparent 30%),
    radial-gradient(circle at 50% 50%, rgba(81, 253, 255, 0.3) 0%, transparent 50%);
  filter: blur(10px);
  opacity: 0;
  animation: revealParticles 1s ease-out forwards;
  pointer-events: none;
  z-index: 2;
}

/* Add reveal sparkles */
.team-reveal-wrapper.revealed::after {
  content: '';
  position: absolute;
  inset: -20px;
  background: 
    radial-gradient(2px 2px at 20% 30%, rgba(255, 255, 255, 0.9) 0%, transparent 100%),
    radial-gradient(2px 2px at 40% 70%, rgba(255, 255, 255, 0.9) 0%, transparent 100%),
    radial-gradient(2px 2px at 60% 20%, rgba(255, 255, 255, 0.9) 0%, transparent 100%),
    radial-gradient(2px 2px at 80% 60%, rgba(255, 255, 255, 0.9) 0%, transparent 100%);
  opacity: 0;
  animation: revealSparkles 1.2s ease-out forwards;
  pointer-events: none;
  z-index: 2;
}

.team-reveal-play-button {
  background: linear-gradient(180deg, #ffd700 0%, #ffa600 100%);
  color: #1c1f25;
  font-family: 'Kim';
  font-size: clamp(18px, 3vw, 24px);
  padding: clamp(12px, 2vh, 16px) clamp(32px, 4vw, 48px);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  animation: fadeInUp 0.6s ease-out;
  text-transform: uppercase;
  font-weight: bold;
  box-shadow: 
    0 0 20px rgba(255, 166, 0, 0.3),
    inset 0 0 10px rgba(255, 255, 255, 0.5);
  position: absolute;
  bottom: 15vh;
}

.team-reveal-play-button:hover {
  transform: translateY(-2px);
  box-shadow: 
    0 0 30px rgba(255, 166, 0, 0.5),
    inset 0 0 15px rgba(255, 255, 255, 0.7);
}

.team-reveal-play-button:active {
  transform: translateY(1px);
  background: linear-gradient(180deg, #ffa600 0%, #ffd700 100%);
}

@keyframes revealCardNew {
  0% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.1);
    filter: brightness(1.5);
  }
  100% {
    transform: scale(1);
    filter: brightness(1);
  }
}

@keyframes revealParticles {
  0% {
    opacity: 0;
    transform: scale(0.8) rotate(-5deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.2) rotate(5deg);
  }
  100% {
    opacity: 0;
    transform: scale(1.5) rotate(10deg);
  }
}

@keyframes revealSparkles {
  0% {
    opacity: 0;
    transform: scale(0.8) rotate(0deg);
  }
  20% {
    opacity: 1;
    transform: scale(1.1) rotate(180deg);
  }
  100% {
    opacity: 0;
    transform: scale(1.3) rotate(360deg);
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeReveal {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
    filter: blur(10px) brightness(2);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) translateY(-10px);
    filter: blur(0) brightness(1.5);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
    filter: blur(0) brightness(1);
  }
}

@keyframes glowEffect {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0;
    transform: scale(1.5);
  }
}

@keyframes sparkleEffect {
  0% {
    opacity: 0;
    transform: scale(0.5) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.2) rotate(180deg);
  }
  100% {
    opacity: 0;
    transform: scale(1.5) rotate(360deg);
  }
}

/* Mobile responsiveness */
@media screen and (max-width: 480px) {
  .team-reveal-grid {
    flex-direction: column;
    gap: 16px;
  }
  
  .team-reveal-wrapper {
    width: clamp(160px, 40vw, 200px);
    height: clamp(120px, 30vw, 160px);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/teamReveal/TeamReveal.style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,8CAA8C;EAC9C,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,8CAA8C;EAC9C,kDAAkD;EAClD,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE;MACE,UAAU;MACV,sCAAsC;MACtC,gCAAgC;IAClC;IACA;MACE,YAAY;MACZ,wCAAwC;MACxC,+BAA+B;IACjC;IACA;MACE,UAAU;MACV,mCAAmC;MACnC,6BAA6B;IAC/B;EACF;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX;;;mFAGiF;EACjF,kBAAkB;EAClB,UAAU;EACV,6CAA6C;EAC7C,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ;;;;sFAIoF;EACpF,UAAU;EACV,gDAAgD;EAChD,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,+CAA+C;AACjD;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX;;;mFAGiF;EACjF,kBAAkB;EAClB,UAAU;EACV,+CAA+C;EAC/C,oBAAoB;EACpB,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ;;;;sFAIoF;EACpF,UAAU;EACV,gDAAgD;EAChD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,sDAAsD;EACtD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,yBAAyB;EACzB,iBAAiB;EACjB;;2CAEyC;EACzC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B;;2CAEyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,mCAAmC;EACrC;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;IACtC,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,wCAAwC;IACxC,+BAA+B;EACjC;EACA;IACE,UAAU;IACV,iCAAiC;IACjC,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;AACF","sourcesContent":[".team-reveal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.85);\n  z-index: 1100;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 48px;\n}\n\n.team-reveal-title {\n  color: #ffffff;\n  font-family: 'Kim';\n  font-size: clamp(24px, 4vw, 36px);\n  text-align: center;\n  text-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\n  animation: fadeInDown 0.6s ease-out;\n  position: absolute;\n  top: 15vh;\n}\n\n.team-reveal-subtitle {\n  text-align: center;\n  color: #ffffff;\n  margin-top: -15px;\n  margin-bottom: 30px;\n  font-size: 0.95rem;\n  opacity: 0.75;\n  font-family: 'Kim';\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3);\n  animation: fadeInDown 0.6s ease-out 0.2s backwards;\n  position: absolute;\n  top: 30vh;\n}\n\n.team-reveal-grid {\n  min-height: 20vh;\n  display: flex;\n  justify-content: center;\n  margin-top: 0;\n  gap: 25px;\n  scrollbar-width: none;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.team-reveal-grid::-webkit-scrollbar {\n  display: none;\n}\n\n@media (max-height: 600px) {\n  .team-reveal-grid {\n    gap: 2vw;\n    margin-top: 0;\n  }\n  \n  .team-reveal-wrapper .endgame_character {\n    transform: scale(1);\n  }\n\n  .team-reveal-wrapper {\n    animation: fadeRevealSmall 0.8s ease-out backwards;\n  }\n\n  @keyframes fadeRevealSmall {\n    0% {\n      opacity: 0;\n      transform: scale(0.3) translateY(20px);\n      filter: blur(10px) brightness(2);\n    }\n    50% {\n      opacity: 0.8;\n      transform: scale(0.55) translateY(-10px);\n      filter: blur(0) brightness(1.5);\n    }\n    100% {\n      opacity: 1;\n      transform: scale(0.5) translateY(0);\n      filter: blur(0) brightness(1);\n    }\n  }\n\n  .team-reveal-title {\n    top: 5vh;\n  }\n\n  .team-reveal-play-button {\n    bottom: 5vh;\n  }\n}\n\n.team-reveal-wrapper {\n  cursor: pointer;\n  transition: all 0.3s ease;\n  animation: fadeReveal 0.8s ease-out backwards;\n  position: relative;\n  z-index: 1;\n  transform: translateZ(0);\n  will-change: transform;\n  isolation: isolate;\n}\n\n/* Add different delays for each card */\n.team-reveal-wrapper:nth-child(1) {\n  animation-delay: 0.3s;\n}\n\n.team-reveal-wrapper:nth-child(2) {\n  animation-delay: 0.6s;\n}\n\n.team-reveal-wrapper:nth-child(3) {\n  animation-delay: 0.9s;\n}\n\n/* Add particle effects */\n.team-reveal-wrapper::before {\n  content: '';\n  position: absolute;\n  inset: -50%;\n  background: \n    radial-gradient(circle at 30% 20%, rgba(81, 253, 255, 0.1) 0%, transparent 30%),\n    radial-gradient(circle at 70% 60%, rgba(81, 253, 255, 0.1) 0%, transparent 30%),\n    radial-gradient(circle at 50% 50%, rgba(81, 253, 255, 0.1) 0%, transparent 50%);\n  filter: blur(10px);\n  opacity: 0;\n  animation: glowEffect 1.2s ease-out backwards;\n  animation-delay: inherit;\n  pointer-events: none;\n  z-index: -1;\n}\n\n/* Add sparkle effects */\n.team-reveal-wrapper::after {\n  content: '';\n  position: absolute;\n  inset: -20px;\n  background: \n    radial-gradient(2px 2px at 20% 30%, rgba(255, 255, 255, 0.8) 0%, transparent 100%),\n    radial-gradient(2px 2px at 40% 70%, rgba(255, 255, 255, 0.8) 0%, transparent 100%),\n    radial-gradient(2px 2px at 60% 20%, rgba(255, 255, 255, 0.8) 0%, transparent 100%),\n    radial-gradient(2px 2px at 80% 60%, rgba(255, 255, 255, 0.8) 0%, transparent 100%);\n  opacity: 0;\n  animation: sparkleEffect 1.5s ease-out backwards;\n  animation-delay: inherit;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.team-reveal-wrapper:hover {\n  transform: translateY(-5px);\n  z-index: 2;\n}\n\n.team-reveal-wrapper.revealed {\n  cursor: default;\n  animation: revealCardNew 0.6s ease-out forwards;\n}\n\n/* Add reveal particle effects */\n.team-reveal-wrapper.revealed::before {\n  content: '';\n  position: absolute;\n  inset: -50%;\n  background: \n    radial-gradient(circle at 30% 20%, rgba(81, 253, 255, 0.3) 0%, transparent 30%),\n    radial-gradient(circle at 70% 60%, rgba(81, 253, 255, 0.3) 0%, transparent 30%),\n    radial-gradient(circle at 50% 50%, rgba(81, 253, 255, 0.3) 0%, transparent 50%);\n  filter: blur(10px);\n  opacity: 0;\n  animation: revealParticles 1s ease-out forwards;\n  pointer-events: none;\n  z-index: 2;\n}\n\n/* Add reveal sparkles */\n.team-reveal-wrapper.revealed::after {\n  content: '';\n  position: absolute;\n  inset: -20px;\n  background: \n    radial-gradient(2px 2px at 20% 30%, rgba(255, 255, 255, 0.9) 0%, transparent 100%),\n    radial-gradient(2px 2px at 40% 70%, rgba(255, 255, 255, 0.9) 0%, transparent 100%),\n    radial-gradient(2px 2px at 60% 20%, rgba(255, 255, 255, 0.9) 0%, transparent 100%),\n    radial-gradient(2px 2px at 80% 60%, rgba(255, 255, 255, 0.9) 0%, transparent 100%);\n  opacity: 0;\n  animation: revealSparkles 1.2s ease-out forwards;\n  pointer-events: none;\n  z-index: 2;\n}\n\n.team-reveal-play-button {\n  background: linear-gradient(180deg, #ffd700 0%, #ffa600 100%);\n  color: #1c1f25;\n  font-family: 'Kim';\n  font-size: clamp(18px, 3vw, 24px);\n  padding: clamp(12px, 2vh, 16px) clamp(32px, 4vw, 48px);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  animation: fadeInUp 0.6s ease-out;\n  text-transform: uppercase;\n  font-weight: bold;\n  box-shadow: \n    0 0 20px rgba(255, 166, 0, 0.3),\n    inset 0 0 10px rgba(255, 255, 255, 0.5);\n  position: absolute;\n  bottom: 15vh;\n}\n\n.team-reveal-play-button:hover {\n  transform: translateY(-2px);\n  box-shadow: \n    0 0 30px rgba(255, 166, 0, 0.5),\n    inset 0 0 15px rgba(255, 255, 255, 0.7);\n}\n\n.team-reveal-play-button:active {\n  transform: translateY(1px);\n  background: linear-gradient(180deg, #ffa600 0%, #ffd700 100%);\n}\n\n@keyframes revealCardNew {\n  0% {\n    transform: scale(1);\n    filter: brightness(1);\n  }\n  50% {\n    transform: scale(1.1);\n    filter: brightness(1.5);\n  }\n  100% {\n    transform: scale(1);\n    filter: brightness(1);\n  }\n}\n\n@keyframes revealParticles {\n  0% {\n    opacity: 0;\n    transform: scale(0.8) rotate(-5deg);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2) rotate(5deg);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.5) rotate(10deg);\n  }\n}\n\n@keyframes revealSparkles {\n  0% {\n    opacity: 0;\n    transform: scale(0.8) rotate(0deg);\n  }\n  20% {\n    opacity: 1;\n    transform: scale(1.1) rotate(180deg);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.3) rotate(360deg);\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeReveal {\n  0% {\n    opacity: 0;\n    transform: scale(0.8) translateY(20px);\n    filter: blur(10px) brightness(2);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05) translateY(-10px);\n    filter: blur(0) brightness(1.5);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n    filter: blur(0) brightness(1);\n  }\n}\n\n@keyframes glowEffect {\n  0% {\n    opacity: 0;\n    transform: scale(0.5);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.5);\n  }\n}\n\n@keyframes sparkleEffect {\n  0% {\n    opacity: 0;\n    transform: scale(0.5) rotate(0deg);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2) rotate(180deg);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1.5) rotate(360deg);\n  }\n}\n\n/* Mobile responsiveness */\n@media screen and (max-width: 480px) {\n  .team-reveal-grid {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .team-reveal-wrapper {\n    width: clamp(160px, 40vw, 200px);\n    height: clamp(120px, 30vw, 160px);\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
